import React from 'react'
import Button from '../../commons/Button/Button'
import SantanderLogo from '../../commons/Icons/SantanderLogoImg'
import ConsultorMais from '../../commons/Icons/ConsultorMais'
import history from '../../../lib/history'
import routes from '../../../config/routes'
import styles from './landingPage.module.scss'

export default function LandingPage() {
  return (
    <div className={styles.containerLading}>
      <div className={styles.header}>
        <h1>
          <SantanderLogo />
        </h1>
      </div>
      <section className={styles.content}>
        <div className={styles.logo}>
          <ConsultorMais />
        </div>
        <div className={styles.containerTitle}>
          <h2 className={styles.title}>
            Reinventamos o jeito de fazer negócios para você crescer mais
          </h2>
          <h3 className={styles.subtitle}>
            Uma nova experiência de gestão comercial, crescimento dos seus
            ganhos e da presença Santander.
          </h3>
        </div>

        <div className={styles.containerButton}>
          <Button
            type="primary"
            margin="8px 12px 0px 0px"
            buttonType="button"
            className={styles.button}
            onClick={() => history.push(routes.login.path)}
          >
            Fazer login
          </Button>
          <Button
            type="outlined"
            margin="8px 24px"
            buttonType="button"
            className={styles.buttonOutline}
            onClick={() => history.push(routes.registerCNPJ.path)}
          >
            Criar conta
          </Button>
        </div>
      </section>
    </div>
  )
}
